export const publicUrls = {
  default: () => '',
  home: () => 'home',
  homes: () => 'homes',
  signUp: () => 'signUp',
  login: () => 'login',
  post: () => 'public/post',
  publicPosts: () => 'public/posts',
  profile: () => 'public/profile',
  forgotPassword: () => 'forgot-password',
  verifyEmail: () => 'verify-email',
  VerifyAccountDeletion: () => 'remove-user',
  privacyPolicy: () => 'privacy-policy',
  resetPassword: () => 'reset-password',
};

export const foundersUrl = {
  feed: () => 'feed',
  post: () => 'post',
  comment: () => 'comment',
  dashboard: () => 'dashboard',
  connections: () => 'connections',
  investors: () => 'investors',
  dealFlow: () => 'deal-flow',
  startupOffers: () => 'startup-offers',
  bookings: () => 'bookings',
  experts: () => 'experts',
  accountSettings: () => 'account-settings',
  allUsers: () => 'users',
  advert: () => 'advert',
  viewAdvert: () => 'view-advert',
  pdfViewer: () => 'account-settings/pdf-viewer',
  videoViewer: () => 'account-settings/video-viewer',
  events: () => 'events',
  eventDetail: (id) => `event/${id}`,
};

export const investorsUrl = {
  dashboard: () => 'dashboard',
  feed: () => 'feed',
  post: () => 'post',
  comment: () => 'comment',
  founders: () => 'founders',
  dealFlow: () => 'deal-flow',
  advert: () => 'advert',
  startupOffers: () => 'startup-offers',
  experts: () => 'experts',
  bookings: () => 'bookings',
  connections: () => 'connections',
  accountSettings: () => 'account-settings',
  events: () => 'events',
  eventDetail: (id) => `event/${id}`,
};

export const expertsUrl = {
  dashboard: () => 'dashboard',
  feed: () => 'feed',
  post: () => 'post',
  comment: () => 'comment',
  founders: () => 'founders',
  connections: () => 'connections',
  accountSettings: () => 'account-settings',
  events: () => 'events',
  eventDetail: (id) => `event/${id}`,
};

export const adminUrl = {
  dashboard: () => 'dashboard',
  accountSettings: () => 'account-settings',
  subscriptions: () => 'admin/subscriptions',
  allUsers: () => 'users',
  userFounders: () => 'founders',
  userExperts: () => 'userexperts',
  userInvestors: () => 'userinvestors',
  userAddExpert: () => 'useraddexpert',
  viewUser: () => 'admin/view-user',
  deals: () => 'admin/deals',
  startupOffers: () => 'startup-offers',
  brands: () => 'brands',
  news: () => 'news',
  adverts: () => 'admin/adverts',
  deletedUsers: () => 'admin/deleted-users',
  subadmins: () => 'admin/subadmins',
  postReports: () => 'post-reports',
  profileReports: () => 'profile-reports',
  profileReportsDetails: () => 'profile-reports-details',
  pitchRequests: () => 'admin/pitch-requests',
  events: () => 'events',
  manageSubscriptionPlans: () => 'admin/manage-subscription-plans',
};

export const privateUrls = {
  survey: () => 'survey',
  viewUser: () => 'view-user',
  viewTermSheet: () => 'view-term-sheet',
  viewPostAgreementStage: () => 'view-post-agreement-stage',
  viewCloseDealFlow: () => 'view-close-deal-flow',
  viewDealFlowTermsheets: () => 'view-deal-flow-termsheets',
  invite: () => 'invite',
  eventDetail: (id) => `event/${id}`,
};
